import { Component, inject } from '@angular/core';

import { Router, RouterModule } from '@angular/router';
import { UtilsService } from '@geekeno/ngx-website/services';
import { ContactFormService } from '../contact-form/contact-form.service';

@Component({
  selector: 'app-navbar',
  imports: [RouterModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  private contactFormService = inject(ContactFormService);
  private router = inject(Router);
  private utilsService = inject(UtilsService);

  dropdownOpen = { svc: false, prd: false };
  isMobileMenuOpen = false;

  constructor() {
    if (this.utilsService.isPlatformBrowser) {
      this.router.events.subscribe(() => {
        this.closeMenu();
      });
    }
  }

  toggleDropdown(name: 'svc' | 'prd', state: boolean) {
    this.dropdownOpen[name] = state;
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }
  closeMenu() {
    this.isMobileMenuOpen = false;
    this.dropdownOpen.svc = false;
    this.dropdownOpen.prd = false;
  }
  openContactModal() {
    this.contactFormService.openForm('navbar');
  }
}
